<template>
  <div class="pcSetting">
    <div class="pcSettingMain">
      <pc-left />
      <pc-center />
      <pc-right />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pcCenter from "./pcCenter.vue";
import pcLeft from "./pcLeft.vue";
import pcRight from "./pcRight.vue";
export default {
  computed: { ...mapGetters(["defaultTheme"]) },
  components: { pcCenter, pcLeft, pcRight },
};
</script>
<style lang="less" scoped>
.pcSetting {
  background: #fff;
  box-sizing: border-box;
  height: 100%;
  .pcSettingMain {
    display: flex;
    height: 100%;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/designPage/components/designMain.vue